import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import { fetchIndustryList } from "../../../Industry/utils/slice";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
/**
 * Renders a form component for adding or editing a record in the Occupational Groups module.
 *
 * @param {object} props - The component props.
 * @param {object} props.form - The form instance.
 * @param {string} props.id - The form ID.
 * @param {function} props.handleSubmit - The function to handle form submission.
 * @param {function} props.onValuesChange - The function to handle form value changes and update the form fields.
 * @param {object} props.editValues - The values to edit in the form fields, if value already exists.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {


  const dispatch = useAppDispatch();

  const [industryList, setIndustryList] = useState<any>([]);

  useEffect(() => {
    if (editValues) {
      form.setFieldsValue(editValues);
    }

    dispatch(fetchIndustryList())
      .then((data: any) => {
        setIndustryList(data.rows);
      })
      .catch((error: any) => error);
  }, [editValues, form]);

  /**
   * Process the form data and handle the form submission.
   */
  const onFinish = (data: any) => {
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="name"
              label="Name"
              rules={rules.name()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              required
              label="Industry"
              name="industry_id"
              showSearch
              className="singleSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={{
                list: industryList,
                valueKey: "id",
                textKey: "industry_name",
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="code"
              label="Code"
              rules={rules.code()}
            />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
